import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useDebounce } from 'use-debounce';
// دالة API جديدة
import { searchPublicCommuniques } from '../../services/communiqueService';
import { ServiceRequest } from '../../types/serviceRequest';
import styles from './CommuniquesResultPage.module.css'; // ملف تنسيقات جديد

interface SearchFilters {
  communique_number?: string;
  applicant_name?: string;
}

const CommuniquesResultPage: React.FC = () => {
  const [results, setResults] = useState<ServiceRequest[]>([]);
  const [filters, setFilters] = useState<SearchFilters>({});
  const [debouncedFilters] = useDebounce(filters, 500);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchResults = async () => {
      // لا تبحث إذا كانت جميع الفلاتر فارغة
      if (!debouncedFilters.communique_number && !debouncedFilters.applicant_name) {
        setResults([]);
        return;
      }
      setIsLoading(true);
      try {
        const data = await searchPublicCommuniques(debouncedFilters);
        setResults(data);
      } catch (error) {
        toast.error('فشل في جلب النتائج.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchResults();
  }, [debouncedFilters]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.pageContainer}>
      <header className={styles.header}>
        <h1>نتائج اجتماعات اللجان</h1>
        <p>ابحث عن حالة طلبك باستخدام رقم البلاغ أو اسمك.</p>
      </header>
      
      <main className={styles.mainContent}>
        <div className={styles.searchFilters}>
          <input name="communique_number" placeholder="ابحث برقم البلاغ..." onChange={handleFilterChange} />
          <input name="applicant_name" placeholder="ابحث باسم مقدم الطلب..." onChange={handleFilterChange} />
        </div>

        <div className={styles.resultsArea}>
          {isLoading ? (
            <p>جاري البحث...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>رقم البلاغ</th>
                  <th>تاريخ الاجتماع</th>
                  <th>اسم مقدم الطلب</th>
                  <th>الخدمة المطلوبة</th>
                  <th>النتيجة</th>
                  <th>ملاحظات</th>
                </tr>
              </thead>
              <tbody>
                {results.length > 0 ? results.map(item => (
                  <tr key={item.id}>
                    <td>{item.communique?.communique_number}</td>
                    <td>{new Date(item.communique?.meeting_date || '').toLocaleDateString('ar-EG')}</td>
                    <td>{item.user?.name}</td>
                    <td>{item.service?.name}</td>
                    <td>
                      {item.status === 'approved' 
                        ? <span className={styles.approved}>مقبول</span> 
                        : <span className={styles.rejected}>مرفوض</span>}
                    </td>
                    <td>{item.rejection_reason || '—'}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={6}>لا توجد نتائج. يرجى استخدام فلاتر البحث أعلاه.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
};

export default CommuniquesResultPage;
